module.exports = __webpack_public_path__ + "static/media/argos-pg1.d8e8743d.jpg";